export default "__VITE_ASSET__BvogUfnG__"